module.exports = __webpack_public_path__ + "static/img/jiqi-txt4.97fa8a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-txt4.png
// module id = 4rwh
// module chunks = 0